export { CustomXAxisTick } from './CutomXAxisTick';
